import { TipoEmpresaServiciosEnum, type DetailEmpresaServiciosAguaModel, type DetailEmpresaServiciosEnergiaModel } from "@api/api";
import { CreateEmpresaServicios } from "./CreateEmpresaServicios";

export class EmpresaServiciosFactory {
  
  /**
   * Crea una nueva instancia de CreateEmpresaServicios para tipo Energía
   */
  static createEmpresaServiciosEnergia(): CreateEmpresaServicios {
    return new CreateEmpresaServicios({
      Tipo: TipoEmpresaServiciosEnum.Energia,
      IdEsave: null,
      SincronizaEsave: false
    });
  }

  /**
   * Crea una nueva instancia de CreateEmpresaServicios para tipo Agua
   */
  static createEmpresaServiciosAgua(): CreateEmpresaServicios {
    return new CreateEmpresaServicios({
      Tipo: TipoEmpresaServiciosEnum.Agua,
      CodigosProvinciaDondeOpera: []
    });
  }

  /**
   * Crea una instancia de CreateEmpresaServicios desde un modelo de detalle existente
   */
  static createFromDetail(detailModel: DetailEmpresaServiciosEnergiaModel | DetailEmpresaServiciosAguaModel): CreateEmpresaServicios {
    return new CreateEmpresaServicios(detailModel);
  }
}
